<template>
  <widget-wrapper
    :id="configItem.chartId"
    :title="chartAttr.title"
    :subTitle="chartAttr.subtitle"
    :addtxt="addText"
    :info="chartAttr.info"
    :empty="empty"
    :loading="loadingbar"
    :isEventStaus="true"
    :listEventStatus="items"
    :searchDate="searchDate"
    :eventState="eventState"
    @ctrl="ctrlClick"
    class="default6 event-status-widget"
  >
    <template v-slot:date-range></template>
    <slot>
      <c-scroll>
        <EventList
          v-for="(item, idx) in items"
          :key="idx"
          :item="item"
          :isSettingMode="isSettingMode"
        />
      </c-scroll>
    </slot>
  </widget-wrapper>
</template>
<script>
import widgetWrapper from '@/components/scpm/widgets/common/widgetWrapperScpm';
import EventList from './EventList';
import widgetMixin from './widgetMixin';
import { getWidgetData } from '../serviceApi';

export default {
  name: 'EventStatusWidget',
  components: { widgetWrapper, EventList },
  mixins: [widgetMixin],
  computed: {
    empty() {
      return this.$util.isEmpty(this.items) || !this.isWidgetAuth;
    },
    eventState() {
      return this.chartAttr.widget.options ? this.chartAttr.widget.options.eventState : '';
    },
    addText() {
      return this.eventState
        ? this.activeState[this.chartAttr.widget.options.eventState]
        : this.$t('label.subTextEventList');
    }
  },
  data() {
    return {
      items: [],
      activeState: {
        ACTIVE: this.$t('label.subTextEventList'),
        ALL: this.$t('label.allEvent')
      }
    };
  },
  methods: {
    getData() {
      let param = {
        size: 100,
        eventState: this.chartAttr.widget.options.eventState,
        sort: 'startDt:desc'
      };
      if (this.searchDate) {
        param.queryStartDt = this.searchDate.queryStartDt;
        param.queryEndDt = this.searchDate.queryEndDt;
      }

      this.items = [];
      getWidgetData('get', this.chartAttr.widget.api, param, this.header).then((data) => {
        if (data instanceof Error) {
          return;
        }
        this.items = data.contents;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
:deep .widget-body {
  padding: 0 0px 20px 20px;
}
:deep .dropdown-group {
  .opus-icon__download_small {
    font-size: 16px !important;
    > svg {
      color: rgba(31, 37, 51, 0.6);
    }
  }
  .opus-icon__arrow_down {
    font-size: 15px !important;
    > svg {
      color: rgba(31, 37, 51, 0.6);
    }
  }
}
</style>
